var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M4.69,16.7a2.93,2.93,0,0,1,1.07-4,4.37,4.37,0,0,1,3.3-.08l2-1.54V9.89A4.49,4.49,0,0,1,9.17,6.71a2.92,2.92,0,0,1,5.84,0,4.49,4.49,0,0,1-1.95,3.18v1l6.75-6.75L13,.28A2.05,2.05,0,0,0,11,.28l-8.61,5A2,2,0,0,0,1.33,7V17a2,2,0,0,0,1,1.78l1.83,1.06,1.89-1.89A2.93,2.93,0,0,1,4.69,16.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M13,23.72l8.61-5a2,2,0,0,0,1-1.78V7a2,2,0,0,0-1-1.78L19.81,4.19l-6.75,6.75v.27l1.84,1.51a4.4,4.4,0,0,1,3.52,0,2.92,2.92,0,1,1-2.92,5.06,4.57,4.57,0,0,1-1.79-3.51L12,12.86,10.47,14a4.56,4.56,0,0,1-1.79,3.76,3,3,0,0,1-2.6.15L4.19,19.81,11,23.72A2.05,2.05,0,0,0,13,23.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationLight);
export default __webpack_public_path__ + "static/media/organization-light.6d6655e3409d3b116256d643a38ea58f.svg";
export { ForwardRef as ReactComponent };